export default __webpack_public_path__ + "static/media/slider2it.65cf52dc.jpg";